/**
 * Jeu d'icônes inlinées (style trait fin, cohérent — CDC §8.3) utilisé par la
 * navigation (menu principal + sidebar experte). Chaque clé `ICON_PATHS` est un
 * identifiant d'icône ; la valeur est le contenu SVG interne (24x24, stroke 2).
 *
 * `emojiToKey` traduit les emojis du catalogue (HUB_NAV_ITEMS) vers ces
 * identifiants afin de supprimer les emojis décoratifs à l'affichage tout en
 * gardant le catalogue comme source de vérité pour les libellés/chemins.
 */
export const ICON_PATHS: Record<string, string> = {
  home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>',
  clipboard: '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/>',
  coin: '<rect x="2" y="6" width="20" height="12" rx="6"/><circle cx="12" cy="12" r="3"/><path d="M2 12h20"/>',
  calculator: '<rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="16" y1="14" x2="16" y2="18"/><path d="M16 10h.01"/><path d="M12 10h.01"/><path d="M8 10h.01"/><path d="M12 14h.01"/><path d="M8 14h.01"/><path d="M12 18h.01"/><path d="M8 18h.01"/>',
  user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
  users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  blocks: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
  pin: '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>',
  receipt: '<path d="M4 2v20l2-1.5L8 22l2-1.5L12 22l2-1.5L16 22l2-1.5L20 22V2l-2 1.5L16 2l-2 1.5L12 2l-2 1.5L8 2 6 3.5z"/><line x1="8" y1="9" x2="16" y2="9"/>',
  compass: '<circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>',
  archive: '<rect x="3" y="3" width="18" height="4" rx="1"/><path d="M5 7v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7"/>',
  folder: '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>',
  chart: '<line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/>',
  filetext: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>',
  brain: '<path d="M12 4a2 2 0 0 1 4 0c.7 0 1.3.3 1.7.8A2 2 0 0 1 20 7a2 2 0 0 1 1 1.7c.6.3 1 1 1 1.7a2 2 0 0 1 0 3.6c0 .7-.4 1.4-1 1.7a2 2 0 0 1-1.4 2.5c-.4.5-1 .8-1.7.8a2 2 0 0 1-2 1.3c-.6.4-1.3.6-2 .6V4z"/>',
  sparkles: '<path d="M12 3l1.9 5.8 6 0.1-4.8 3.7 1.8 5.7-4.9-3.6-4.9 3.6 1.8-5.7-4.8-3.7 6-0.1z"/>',
  image: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>',
  target: '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>',
  handshake: '<path d="M11 17l-5-5a2 2 0 1 1 3-3l4 4 1-1-4-4a2 2 0 1 1 3-3l6 6a2 2 0 0 1 0 3l-4 4a2 2 0 0 1-3 0l-1-1"/>',
  warning: '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
  box: '<path d="M21 8v8a2 2 0 0 1-1 1.7l-7 4a2 2 0 0 1-2 0l-7-4A2 2 0 0 1 3 16V8a2 2 0 0 1 1-1.7l7-4a2 2 0 0 1 2 0l7 4A2 2 0 0 1 21 8z"/><polyline points="3.3 7 12 12 20.7 7"/><line x1="12" y1="22" x2="12" y2="12"/>',
  ruler: '<path d="M21.3 15.3L8.7 2.7a2.4 2.4 0 0 0-3.4 0L2.7 5.3a2.4 2.4 0 0 0 0 3.4l12.6 12.6c.9.9 2.5.9 3.4 0l2.6-2.6a2.4 2.4 0 0 0 0-3.4z"/><path d="M9 6l1 1"/><path d="M12 9l1 1"/><path d="M15 12l1 1"/>',
  pencil: '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>',
  radar: '<path d="M12 12v-2a4 4 0 0 0-4-4H4"/><circle cx="12" cy="12" r="10"/><path d="M5 12.9h.01"/>',
  calendar: '<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  timer: '<line x1="10" y1="2" x2="14" y2="2"/><line x1="12" y1="14" x2="15" y2="11"/><circle cx="12" cy="14" r="8"/>',
  notebook: '<path d="M2 6h4"/><path d="M2 10h4"/><path d="M2 14h4"/><path d="M2 18h4"/><rect x="6" y="2" width="16" height="20" rx="2"/><path d="M10 16h2"/><path d="M10 8h7"/>',
  rocket: '<path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>',
  trending: '<polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>',
  landmark: '<line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7"/>',
  'lock': '<rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
  plus: '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>',
  briefcase: '<rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>',
  building: '<rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M8 10h.01"/><path d="M16 10h.01"/><path d="M12 10h.01"/><path d="M8 14h.01"/><path d="M16 14h.01"/><path d="M12 14h.01"/>',
  monitor: '<rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>',
  wrench: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
  activity: '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>',
};

const EMOJI_TO_KEY: Record<string, string> = {
  '🏠': 'home', '🖥️': 'home', '🖥': 'home',
  '📋': 'clipboard',
  '💰': 'coin',
  '🧮': 'calculator',
  '👤': 'user', '🪪': 'user',
  '👥': 'users',
  '🧱': 'blocks',
  '📍': 'pin',
  '🧾': 'receipt',
  '🧭': 'compass',
  '🗂️': 'archive', '🗂': 'archive',
  '📁': 'folder',
  '📊': 'chart',
  '📄': 'filetext',
  '🧠': 'brain',
  '✨': 'sparkles',
  '🖼️': 'image', '🖼': 'image',
  '🎯': 'target',
  '🤝': 'handshake',
  '⚠️': 'warning', '⚠': 'warning',
  '📦': 'box',
  '📐': 'ruler',
  '📝': 'pencil',
  '📡': 'radar',
  '📅': 'calendar',
  '⏱': 'timer',
  '📓': 'notebook',
  '🚀': 'rocket',
  '📈': 'trending',
  '🏛️': 'landmark', '🏛': 'landmark',
  '🔐': 'lock', '🔒': 'lock',
  '➕': 'plus',
  '💼': 'briefcase',
  '🏢': 'building',
  '💻': 'monitor',
  '🔧': 'wrench',
  '⚕️': 'activity', '⚕': 'activity',
};

export function normalizeIcon(icon: string): string {
  return icon.replace(/\uFE0F/g, '').replace(/\u200D/g, '').trim();
}

/** Résout un emoji du catalogue vers l'identifiant d'icône (ou l'emoji si inconnu). */
export function resolveIcon(icon: string): string {
  if (ICON_PATHS[icon]) return icon;
  const key = EMOJI_TO_KEY[normalizeIcon(icon)];
  if (key) return key;
  return icon;
}
